import React, { useEffect, useState } from 'react';
import { notification, Row, Transfer, Card } from 'antd';
import { useQuery } from 'react-query';
import { useTransfer } from '../../../../hooks/useTransfer';
import {
  Mgproduct,
  getProductConfigList,
  ProductConfig,
  getParValuesByBroker,
  removeBrokerParFiltering,
  createBrokerParFiltering,
} from '../../../../services/parametersService';
import moment from 'moment';
import Title from 'components/Title';
import _ from 'lodash';

type MGProductParListTransferProps = {
  mgid: number;
  tpidbroker: number;
};

const BokerProductTransfer = (props: MGProductParListTransferProps) => {
  const { onSelectChange, selectedKeys } = useTransfer();
  let displayNotification = true;
  // eslint-disable-next-line no-unused-vars
  const [prAssociated, setPrAssociated] = useState<string[]>();
  // eslint-disable-next-line no-unused-vars
  const [productList, setProductList] = useState<ProductConfig[]>();

  const { mgid, tpidbroker } = props;

  const { data: prList } = useQuery(['getMgByPrcode'], () =>
    getProductConfigList()
      .then((res) => res.list || [])
      .catch((res) => [])
  );

  const { data: prListAssociated, refetch: ref } = useQuery(
    [
      'getParValuesByBroker',
      {
        mgid: mgid,
        parcode: 'PRODUCT',
        tpidbroker: tpidbroker,
      },
    ],
    () =>
      getParValuesByBroker({
        mgid: mgid,
        parcode: 'PRODUCT',
        tpidbroker: tpidbroker,
      })
        .then((res) => res.list || [])
        .catch((res) => [])
  );
  useEffect(() => {
    if (!_.isNil(prListAssociated) && !_.isNil(prList)) {
      const prlistPrCode = prListAssociated.map((mg) => String(mg.parvalue));
      setPrAssociated(prlistPrCode);
      setProductList(prList);
    }
  }, [prListAssociated, prList]);
  const onChange = (
    targetKeys: string[],
    direction: string,
    moveKeys: string[]
  ) => {
    if (direction === 'left') {
      // eslint-disable-next-line array-callback-return
      moveKeys.forEach((key) => {
        let parlist = prListAssociated?.find(
          (parlist) => parlist.parvalue === key 
        );
        removeBrokerParFiltering({
          filterid: parlist?.filterid ?? 0,
          tpidbroker: tpidbroker,
        }).then((res) => {
          if (res.code === '200') {
            ref();
            notification.success({
              message: res.message,
            });
          }
        });
      });
    } else {
      // eslint-disable-next-line array-callback-return
      moveKeys.forEach((key) => {
        const mgProductrequest: Mgproduct = {
          enddate: '',
          mgid: mgid,
          prcode: key,
          startdate: moment(Date.now()).format('YYYY-MM-DD'),
        };
        createBrokerParFiltering({
          request: {
            filterid: 0,
            flagdefault: false,
            mgid: mgid,
            parcode: 'PRODUCT',
            parvalue: key,
            tpidbroker: tpidbroker,
          },
          tpidbroker: tpidbroker,
        }).then((res) => {
          if (res.code === '200') {
            ref();
            notification.success({
              message: res.message,
            });
          }
        });
      });
    }
  };

  return (
    <div>
      <Card
        title={<Title level={4} comcode="productCompany"></Title>}
        size="small"
      >
        <Row>
          <Transfer
            style={{ width: '100%' }}
            dataSource={prList ?? []}
            showSearch
            targetKeys={
              prListAssociated?.map((product) => product.parvalue) ?? []
            }
            onChange={onChange}
            selectedKeys={selectedKeys}
            onSelectChange={onSelectChange}
            titles={['availableValues', 'associatedValues']}
            render={(pr) => pr.prlabel}
            rowKey={(pr) => pr.prcode}
            listStyle={{
              width: '100%',
              height: 300,
            }}
          />
        </Row>
      </Card>
    </div>
  );
};

export default BokerProductTransfer;
